import Immutable from 'immutable';
import { GET_COLORS } from '../constants';

const INITIAL_STATE = Immutable.fromJS({colors: [], colorsCount: 0});

export default function (state = INITIAL_STATE, action)
{
	let nextState = state.toJS();

	switch (action.type) {
		case GET_COLORS:
            nextState.colors = action.payload.rows
            nextState.colorsCount = action.payload.count
        break;
        default:

        break;
	}

	return state.merge(nextState);
}
